export default "__VITE_ASSET__23a66820__"